/**
 * List for grid component.
 *
 * @author Roman Stoian <r.stoyan@infomir.com>.
 */

/* eslint no-path-concat: 0 */

'use strict';


//TODO inherit from Layout List
var List = require('mag-component-list'),
    keys = require('stb-keys');


/**
 * MainPanel list implementation.
 *
 * Each data item can be either a primitive value or an object with these fields:
 *
 *  Name    | Description
 * ---------|-------------
 *  value   | actual cell value to render
 *  mark    | is it necessary or not to render this cell as marked
 *
 * @constructor
 * @extends List
 *
 * @param {Object}   [config={}]           - init parameters (all inherited from the parent)
 * @param {Array}    [config.data=[]]      - component data to visualize
 * @param {Function} [config.render]       - method to build each grid cell content
 * @param {Function} [config.navigate]     - method to move focus according to pressed keys
 * @param {number}   [config.size=6]       - amount of visible items on a page
 * @param {number}   [config.bufferSize=3] - amount of buffered items
 * @param {number}   [config.focusIndex]   - list item index to make item focused (move view window to this position)
 * @param {boolean}  [config.cycle=true]   - allow or not to jump to the opposite side of a list when there is nowhere to go next
 * @param {boolean}  [config.scroll=null]  - associated ScrollBar component link
 *
 * @fires module:stb/ui/list~List#click:item
 */
function ItemList ( config ) {
    // current execution context
    var self = this;

    // sanitize
    config = config || {};

    if ( DEVELOP ) {
        if ( typeof config !== 'object' ) {
            throw new Error(__filename + ': wrong config type');
        }
        // init parameters checks
        if ( 'className' in config && typeof config.className !== 'string' ) {
            throw new Error(__filename + ': wrong or empty config.className');
        }
    }

    /**
     * Amount of visible items on a page.
     *
     * @type {number}
     */
    this.bufferSize = 3;
    // this.hasEmptyItems = config.hasEmptyItems || false;
    // this.propagate = config.propagate || false;

    config.$body = document.createElement('div');
    config.$body.className = 'body';
    config.type = this.TYPE_VERTICAL;

    List.call(this, config);

    if ( config.title ) {
        if ( config.title instanceof HTMLElement ) {
            this.$title = config.title;
        } else {
            this.$title = document.createElement('div');
            this.$title.className = 'title';
            this.$title.innerText = config.title;
        }
        this.$node.appendChild(this.$title);
    }
    this.$node.appendChild(this.$body);

    this.inFocus = false;
    this.addListener('focus', function () {
        if ( self.$focusItem ) {
            self.$focusItem.focus();
        }
        self.inFocus = true;
    });
    this.addListener('blur', function () {
        self.inFocus = false;
    });
}

// inheritance
ItemList.prototype = Object.create(List.prototype);
ItemList.prototype.constructor = ItemList;

// set component name
ItemList.prototype.name = 'mag-component-grid-list';


/**
 * Init or re-init of the component inner structures and HTML.
 *
 * @param {Object} config - init parameters (subset of constructor config params)
 */
ItemList.prototype.init = function ( config ) {
    var self = this;

    if ( DEVELOP ) {
        if ( arguments.length !== 1 ) {
            throw new Error(__filename + ': wrong arguments number');
        }
        if ( typeof config !== 'object' ) {
            throw new Error(__filename + ': wrong config type');
        }
    }

    this.cycle = config.cycle || false;

    // apply ScrollBar link
    if ( config.scroll ) { this.scroll = config.scroll; }

    // custom render method
    if ( config.render ) {
        if ( DEVELOP ) {
            if ( typeof config.render !== 'function' ) {
                throw new Error(__filename + ': wrong config.render type');
            }
        }

        // apply
        this.renderItem = config.render;
    }

    // list items amount on page
    if ( config.size ) {
        if ( DEVELOP ) {
            if ( +config.size !== config.size ) {
                throw new Error(__filename + ': config.size must be a number');
            }
            if ( config.size <= 0 ) {
                throw new Error(__filename + ': config.size should be positive');
            }
        }

        // apply
        this.size = config.size;
    }

    if ( config.bufferSize ) {
        if ( DEVELOP ) {
            if ( +config.bufferSize !== config.bufferSize ) {
                throw new Error(__filename + ': config.bufferSize must be a number');
            }
            if ( config.bufferSize <= 0 ) {
                throw new Error(__filename + ': config.size should be positive');
            }
        }

        // apply
        this.bufferSize = config.bufferSize;
    }

    if ( config.events ) {
        // apply all given events
        Object.keys(config.events).forEach(function ( name ) {
            self.events[name] = null;
            self.addListener(name, config.events[name]);
        });
    }

    this.focusPosition = config.focusPosition || Math.ceil(this.size / 2);
    this.startIndex = 0;

    this.setData(config);
};

ItemList.prototype.createItem = function () {
    var self = this,
        item = document.createElement('div');

    item.className = 'item hidden';

    item.addEventListener('click', function ( event ) {
        if ( item.data ) {
            self.focusItem(item);

            // there are some listeners
            if ( self.events['click:item'] ) {
                // notify listeners
                self.emit('click:item', {$item: item, event: event});
            }
        }
    });

    return item;
};

/**
 * Set data and render inner structures and HTML.
 *
 * @param {Object} config - init parameters (subset of constructor config params)
 */
ItemList.prototype.setData = function ( config ) {
    if ( config.data ) {
        if ( DEVELOP ) {
            if ( !Array.isArray(config.data) ) { throw new Error(__filename + ': wrong config.data type'); }
        }
        // prepare user data
        this.bufferBefore = [];
        this.mainList = [];
        this.bufferAfter = [];
    }

    List.prototype.setData.call(this, config);
};


/**
 * Refresh data and render inner structures and HTML.
 */
ItemList.prototype.refreshData = function () {
    var config = {},
        self = this;

    if ( this.query && this.query.getter ) {
        this.query.getter(function ( listData ) {
            if ( listData.length === 0 ) {
                if ( self.parent.removeItem ) {
                    self.parent.removeItem(self.query);

                    return;
                }
            }
            if ( self.$focusItem ) {
                config.focusIndex = self.$focusItem.index;
                if ( listData.length <= config.focusIndex ) {
                    config.focusIndex = listData.length - 1;
                }
            }
            config.data = listData;
            if ( self.parent.data && self.parent.data.length > self.index ) {
                self.parent.data[self.index].data = config.data;
            }
            self.setData(config);
        });
    }
};


/**
 * Shift the visible view window event.
 *
 * @event module:stb/ui/list~List#move:view
 *
 * @param {Element} $item - item to init
 * @param {Object} data - data to fill $item
 * @param {number} index - data index in Array
 *
 * @return {Element} $item
 */
ItemList.prototype.initItem = function ( $item, data, index ) {
    if ( data && $item ) {
        // correct inner data/index and render
        $item.data  = data;
        $item.index = index;
        this.renderItem($item, data);
    } else {
        // nothing to render
        $item.data = $item.index = undefined;
        $item.innerHTML = '&nbsp;';
    }

    return $item;
};


ItemList.prototype.checkClassStates = function () {
    if ( this.data.length > this.size - 1 ) {
        if ( this.$focusItem.index + 1 < this.focusPosition ) {
            this.$body.classList.remove('noEmptyBefore');
        } else {
            this.$body.classList.add('noEmptyBefore');
        }

        if ( this.$focusItem.index === this.data.length - 1 ) {
            this.$body.classList.add('emptyAfter');
        } else {
            this.$body.classList.remove('emptyAfter');
        }
    } else {
        this.$body.classList.remove('emptyAfter');
        this.$body.classList.remove('noEmptyBefore');
    }

};


/**
 * Init the visible window.
 *
 * @param {number} viewIndex - start position to render
 *
 * @return {boolean} operation - status
 *
 * @fires module:stb/ui/list~List#move:view
 */
ItemList.prototype.renderView = function ( viewIndex ) {
    var count = 0,
        $item, index, prevIndex,
        currIndex;

    if ( DEVELOP ) {
        if ( arguments.length !== 1 ) {
            throw new Error(__filename + ': wrong arguments number');
        }
        if ( +viewIndex !== viewIndex ) {
            throw new Error(__filename + ': viewIndex must be a number');
        }
        if ( viewIndex < 0 ) {
            throw new Error(__filename + ': viewIndex should be more than zero');
        }
        // if ( viewIndex >= this.data.length ) {
        //     throw new Error(__filename + ': viewIndex should be less than data size');
        // }
    }

    if ( this.viewIndex === viewIndex ) {
        return true;
    }

    while ( this.$body.firstChild ) {
        this.$body.removeChild(this.$body.firstChild);
    }

    prevIndex = this.viewIndex;
    this.viewIndex = currIndex = viewIndex || 0;

    this.startIndex = this.viewIndex - this.bufferSize;
    if ( this.startIndex < 0 ) {
        count = Math.abs(this.startIndex);
        this.startIndex = 0;
    }
    viewIndex = this.startIndex;

    this.bufferBefore = [];
    this.mainList = [];
    this.bufferAfter = [];
    count = this.bufferSize - count;
    for ( index = 0; index < count; index++ ) {
        $item = this.createItem();
        $item = this.initItem($item, this.data[viewIndex], viewIndex);
        this.$body.appendChild($item);
        $item.classList.add('hidden');
        this.bufferBefore.push($item);
        viewIndex++;
    }
    count = count + this.size;
    for ( index; index < count; index++ ) {
        if ( index >= this.data.length ) {
            break;
        }
        $item = this.createItem();
        $item = this.initItem($item, this.data[viewIndex], viewIndex);
        this.$body.appendChild($item);
        $item.classList.remove('hidden');
        this.mainList.push($item);
        viewIndex++;
    }

    count = (2 * this.bufferSize) + this.size + this.startIndex;
    count = this.data.length > count ? count : this.data.length;
    for ( index; index < count; index++ ) {
        $item = this.createItem();
        $item = this.initItem($item, this.data[viewIndex], viewIndex);
        this.$body.appendChild($item);
        this.bufferAfter.push($item);
        $item.classList.add('hidden');
        viewIndex++;
    }

    // there are some listeners
    if ( this.events['move:view'] ) {
        // notify listeners
        this.emit('move:view', {prevIndex: prevIndex, currIndex: currIndex});
    }

    return false;
};


/* eslint max-statements: 0 */
/* eslint complexity: 0 */
/**
 * Move focus to the given direction.
 *
 * @param {number} direction - arrow key code
 *
 * @fires module:stb/ui/list~List#overflow
 */
ItemList.prototype.move = function ( direction ) {
    var item, index, delta,
        lastIndex, length;

    if ( DEVELOP ) {
        if ( arguments.length !== 1 ) {
            throw new Error(__filename + ': wrong arguments number');
        }
        if ( +direction !== direction ) {
            throw new Error(__filename + ': direction must be a number');
        }
    }

    // empty list
    if ( !this.data.length || !this.$focusItem ) {

        return;
    }
    switch ( direction ) {
        case keys.left:
            if ( this.$focusItem.index > 0 ) {
                if ( this.$focusItem.index < this.viewIndex + this.focusPosition && this.viewIndex > 0 ) {
                    this.viewIndex--;
                    lastIndex = this.bufferBefore[0].index;
                    lastIndex--;
                    item = this.bufferBefore.pop();
                    item.classList.remove('hidden');
                    this.mainList.unshift(item);

                    if ( this.size < this.mainList.length ) {
                        item = this.mainList.pop();
                        this.bufferAfter.unshift(item);
                        item.classList.add('hidden');
                    }

                    if ( this.bufferAfter.length > this.bufferSize ) {
                        item = this.bufferAfter.pop();
                        this.$body.removeChild(item);
                    }

                    if ( lastIndex >= 0 ) {
                        item = this.createItem();
                        item = this.initItem(item, this.data[lastIndex], lastIndex);
                        this.$body.insertBefore(item, this.$body.firstChild);
                        this.bufferBefore.unshift(item);
                    }
                }

                this.focusItem(this.$focusItem.previousSibling);
            } else {
                if ( this.cycle ) {
                    // jump to the beginning of the list
                    this.move(keys.end);
                }
                if ( this.events['overflow'] ) {
                    // notify listeners
                    this.emit('overflow', {direction: direction, cycle: false});
                }
                // }
            }
            break;
        case keys.right:
            if ( this.$focusItem.index < this.data.length - 1 ) {
                if ( this.$focusItem.index + 1 >= this.focusPosition && this.bufferAfter.length ) {
                    item = this.bufferAfter.shift();
                    this.mainList.push(item);
                    item.classList.remove('hidden');

                    this.viewIndex++;
                    if ( this.mainList.length > this.size ) {
                        item = this.mainList.shift();
                        item.classList.add('hidden');
                        this.bufferBefore.push(item);
                    }

                    if ( this.bufferBefore.length > this.bufferSize ) {
                        item = this.bufferBefore.shift();
                        this.$body.removeChild(item);
                    }

                    if ( this.size - this.mainList.length && this.bufferAfter.length ) {
                        item = this.bufferAfter.shift();
                        this.mainList.push(item);
                        item.classList.remove('hidden');
                    }

                    length = this.bufferAfter.length;
                    if ( length ) {
                        delta = this.bufferSize - length;
                        for ( index = 0; index < delta; index++ ) {
                            item = this.bufferAfter[this.bufferAfter.length - 1];
                            if ( !item ) {
                                break;
                            }
                            lastIndex = item.index;
                            lastIndex++;
                            if ( lastIndex >= this.data.length ) {
                                break;
                            }

                            item = this.createItem();
                            this.$body.appendChild(item);
                            item = this.initItem(item, this.data[lastIndex], lastIndex);
                            this.bufferAfter.push(item);
                        }
                    }
                }

                this.focusItem(this.$focusItem.nextSibling);
            } else {
                if ( this.cycle ) {
                    // jump to the beginning of the list
                    this.move(keys.home);
                }
                if ( this.events['overflow'] ) {
                    // notify listeners
                    this.emit('overflow', {direction: direction, cycle: false});
                }
            }

            break;
        case keys.home:
            this.focusIndex(0);
            break;
        case keys.end:
            this.focusIndex(this.data.length - 1);
            break;
    }
};


/**
 * Highlight the given DOM element as focused.
 * Remove focus from the previously focused item and generate associated event.
 *
 * @param {Element} $item - element to focus
 *
 * @return {boolean} operation status
 *
 * @fires module:stb/ui/list~List#focus:item
 * @fires module:stb/ui/list~List#blur:item
 */
ItemList.prototype.focusItem = function ( $item ) {
    var $prev = this.$focusItem;

    if ( DEVELOP ) {
        if ( arguments.length !== 1 ) {
            throw new Error(__filename + ': wrong arguments number');
        }
    }

    // different element
    if ( $item && $prev !== $item ) {
        if ( DEVELOP ) {
            if ( !($item instanceof HTMLElement) ) {
                throw new Error(__filename + ': wrong $item type');
            }
            if ( $item.parentNode !== this.$body ) {
                throw new Error(__filename + ': wrong $item parent element');
            }
        }

        // some item is focused already
        if ( $prev !== null ) {
            if ( DEVELOP ) {
                if ( !($prev instanceof HTMLElement) ) {
                    throw new Error(__filename + ': wrong $prev type');
                }
            }

            // style
            $prev.classList.remove('focus');
            //$prev.classList.remove('theme-focus');

            // there are some listeners
            if ( this.events['blur:item'] ) {
                /**
                 * Remove focus from an element.
                 *
                 * @event module:stb/ui/list~List#blur:item
                 *
                 * @type {Object}
                 * @property {Element} $item previously focused HTML element
                 */
                this.emit('blur:item', {$item: $prev});
            }
        }
        // reassign
        this.$focusItem = $item;

        this.$focusItem.data = this.data[this.$focusItem.index];

        // correct CSS
        $item.classList.add('focus');
        //$item.classList.add('theme-focus');

        // there are some listeners
        if ( this.events['focus:item'] ) {
            /**
             * Set focus to a DOM element.
             *
             * @event module:stb/ui/list~List#focus:item
             *
             * @type {Object}
             * @property {Element} $prev old/previous focused HTML element
             * @property {Element} $curr new/current focused HTML element
             */
            if ( this.inFocus ) {
                this.emit('focus:item', {$prev: $prev, $curr: $item});
            }
        }

        // there are some listeners
        if ( this.events['select:item'] ) {
            /**
             * Set focus to a list item.
             *
             * @event module:stb/ui/list~List#select:item
             *
             * @type {Object}
             * @property {Element} $item new/current focused item
             */
            this.emit('select:item', {$item: $item});
        }

        this.checkClassStates();

        return true;
    }

    // nothing was done
    return false;
};


/**
 * Set the given item focused by item index.
 *
 * @param {number} index - item data index
 */
ItemList.prototype.focusIndex = function ( index ) {
    var viewIndex = this.viewIndex || 0,
        tempIndex;

    if ( DEVELOP ) {
        if ( +index !== index ) {
            throw new Error(__filename + ': index must be a number');
        }
        if ( index < 0 ) {
            throw new Error(__filename + ': index should be positive');
        }
    }

    if ( index >= this.data.length ) {
        this.renderView(0);
        this.focusItem(this.$body.firstChild);

        return;
    }

    if ( index < this.size ) {
        viewIndex = 0;
        if ( this.hasEmptyItems && index > this.focusPosition ) {
            viewIndex++;
        }
        this.renderView(viewIndex);
        index = index - viewIndex;
        this.focusItem(this.mainList[index]);

        return;
    }

    if ( index >= viewIndex + this.focusPosition ) {
        viewIndex = index - this.focusPosition;
        if ( viewIndex + this.size < this.data.length ) {
            this.renderView(viewIndex);
            this.focusItem(this.mainList[this.focusPosition]);
        } else {
            if ( this.data.length >= this.size ) {
                viewIndex = this.data.length - this.size;
                if ( this.hasEmptyItems ) {
                    viewIndex++;
                }
                this.renderView(viewIndex);
            } else {
                viewIndex = 0;
                if ( this.hasEmptyItems ) {
                    viewIndex++;
                }
                this.renderView(viewIndex);
            }
            tempIndex = index - this.viewIndex;
            this.focusItem(this.mainList[tempIndex]);
        }

        return;
    }

    viewIndex = index - this.focusPosition;
    this.renderView(viewIndex);
    tempIndex = index - viewIndex;
    this.focusItem(this.mainList[tempIndex]);
};

// public
module.exports = ItemList;
